export function isAddedAtCompatible(addedAt, fulfillmentMethod) {
    if (fulfillmentMethod === null)
        return true;
    switch (addedAt) {
        case "Everywhere":
            return true;
        case "DeliveryOnly":
            return fulfillmentMethod === "Delivery";
        case "TakeawayOnly":
            return fulfillmentMethod === "Takeaway";
        case "RestaurantOnly":
            return fulfillmentMethod === "DineIn";
        case "DeliveryAndTakeaway":
            return (fulfillmentMethod === "Delivery" || fulfillmentMethod === "Takeaway");
        case "RestaurantAndTakeaway":
            return fulfillmentMethod === "DineIn" || fulfillmentMethod === "Takeaway";
    }
}
